// components/Documents/DocumentPreviewDialog.jsx
import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import {
  Close as CloseIcon,
  InsertDriveFileOutlined,
  FileDownloadOutlined,
} from "@mui/icons-material";

const DocumentPreviewDialog = ({ open, onClose, url, fileType, onDownload }) => {
  const isViewable = ["pdf", "jpg", "jpeg", "png", "gif"].includes(fileType);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          maxHeight: "90vh",
          bgcolor: "#1A1A2E",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
          borderBottom: "1px solid rgba(255,255,255,0.1)",
        }}
      >
        <Typography variant="subtitle1" fontWeight={600} color="white">
          Document Preview
        </Typography>
        <IconButton onClick={onClose} sx={{ color: "white" }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        {fileType === "pdf" ? (
          <Box sx={{ width: "100%", height: "70vh" }}>
            <iframe
              src={`${url}#toolbar=1`}
              width="100%"
              height="100%"
              style={{ border: "none", borderRadius: "8px" }}
              title="Document Preview"
            />
          </Box>
        ) : isViewable ? (
          <Box
            component="img"
            src={url}
            alt="Document Preview"
            sx={{
              maxWidth: "100%",
              maxHeight: "70vh",
              objectFit: "contain",
              borderRadius: "8px",
            }}
          />
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: 4,
              gap: 2,
            }}
          >
            <InsertDriveFileOutlined sx={{ fontSize: 80, color: "rgba(255,255,255,0.3)" }} />
            <Typography variant="body1" color="rgba(255,255,255,0.7)">
              Preview not available for this file type
            </Typography>
            <Button
              variant="contained"
              startIcon={<FileDownloadOutlined />}
              onClick={() => {
                onDownload();
                onClose();
              }}
              sx={{ mt: 2 }}
            >
              Download to View
            </Button>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DocumentPreviewDialog;